import { FC, PropsWithChildren } from 'react';
import { cx } from '@emotion/css';
import { useNavigation } from '../context/navigation-context-provider';
import { AppSwitcherSection } from './app-switcher-section';
import { StihlIdMenuSection } from './stihl-id-menu-section';
import { MetaNavSection } from './meta-nav-section';
import { AppNameSection } from './app-name-section';
import { CustomSlotSection } from './custom-slot-section';
import { useTranslation } from 'next-i18next';
import Hamburger from './hamburger-react';

export const TopBar: FC<PropsWithChildren<{ testIdNamespace?: string }>> = ({ children, testIdNamespace = 'topbar' }) => {
  const { t } = useTranslation('shared');
  const {
    config: { layout, shouldHideMainNavOnDesktop },
    state: { showMobileMenu },
    setState,
  } = useNavigation();

  return (
    <header
      className={cx(
        'relative z-20 h-[3.125rem] justify-between border-b border-secondary-mid bg-primary-white print:hidden',
        layout === 'compact' ? 'stihl-page-container-grid' : 'flex',
        shouldHideMainNavOnDesktop ? 'desktop:h-[3.75rem] desktop:bg-secondary-light' : 'tablet:h-[3.75rem] tablet:bg-secondary-light'
      )}
      data-testid={`${testIdNamespace}_container`}
    >
      <div
        className={cx(
          'col-span-3 col-start-1 flex items-center gap-2 [@media(min-width:400px)]:gap-4 [@media(min-width:530px)]:col-span-2 [@media(min-width:530px)]:col-start-2',
          layout === 'full' && 'flex-1'
        )}
      >
        <AppNameSection increaseLogoSizeOnBreakpoint={shouldHideMainNavOnDesktop ? 'desktop' : 'tablet'} />
        <CustomSlotSection>{children}</CustomSlotSection>

        <div className={cx('hidden items-center', shouldHideMainNavOnDesktop ? 'desktop:flex' : 'tablet:flex')}>
          <MetaNavSection />
          <AppSwitcherSection />
          <StihlIdMenuSection />
        </div>

        <div
          className={cx(
            'flex h-10 w-12 items-center justify-center',
            showMobileMenu && 'border-l border-secondary-mid',
            shouldHideMainNavOnDesktop ? 'desktop:hidden' : 'tablet:hidden'
          )}
        >
          <Hamburger
            size={18}
            toggled={showMobileMenu}
            onToggle={(showMobileMenuParam) =>
              setState((state) => ({
                ...state,
                showMobileMenu: showMobileMenuParam,
                showMobileSubMenu: null,
              }))
            }
            data-testid={`${testIdNamespace}_container_hamburger`}
            hideOutline={false}
            label={showMobileMenu ? t('topBar_meta_close_menu') : t('topBar_meta_open_menu')}
            controls="topbar-hamburger"
          />
        </div>
      </div>
    </header>
  );
};
